export const IMAGE_QUICK_TRANSITION_TIME = 100;
export const IMAGE_NORMAL_TRANSITION_TIME = 300;
export const IMAGE_TRANSITION_EASING = 'linear';
export const IMAGE_BLUR_RADIUS = '15px';
export const IMAGE_BLUR_MODE = 'always';
export const IMAGE_DEFAULT_QUALITY = {
  1: 75,
  2: 50,
  3: 35,
  4: 23,
  5: 20
};